module.exports = __webpack_public_path__ + "img/_attach.4473d345.svg";